
/* opcao de comprar no card de produto */
function addToCartFromProductCart(id){
	fetch('/cart/add.js', {
		method: 'POST',
		headers: {
		  'Content-Type': 'application/json',
		},
		body: JSON.stringify({ quantity: 1, id: id })
	})
	.then(response => response.json())
	.then(data => {
		// document.dispatchEvent(new CustomEvent("product:added", {detail:{product:data}}));
		document.dispatchEvent(new CustomEvent("cart:refresh"));
		document.querySelector('header a[href="/cart"]').click();
	})
	.catch(error => {
		console.error('Error:', error);
	});
}
function createAddToCartBtn(element){
	var addToCartBtn = document.createElement('button');
	addToCartBtn.type = "button";
	addToCartBtn.className = "add-to-cart-btn-card button w-full";
	addToCartBtn.innerHTML = "<span>Adicionar à sacola</span>"
	addToCartBtn.dataset.id = element.dataset.id;
	addToCartBtn.addEventListener('click', function(){
        addToCartBtn.innerHTML = "<span>Adicionado</span>"
		addToCartFromProductCart(element.dataset.id);
	});	
	element.parentElement.after(addToCartBtn);
}
function removeAddToCartBtn(el){
	if(el.querySelector('.add-to-cart-btn-card')){
		el.querySelector('.add-to-cart-btn-card').remove();
	}
}
function getProductListVariants(productId){
	var productListVariants = document.querySelectorAll('.product-list-item-variants');
	var content;
	productListVariants.forEach(function(productListVariant){
	  	if(productListVariant.dataset.productId === productId){
			content = JSON.parse(productListVariant.dataset.value);
	  	}
	});
	return content;
}
function changeImageToOptionSelected(element, image){
    var productImages = element.closest('.product-card').querySelectorAll('img.product-card__image');
    if(productImages && image){
      productImages.forEach(function(productImage){
        productImage.srcset = "";
        productImage.src = image;
      });
    } else if(productImages && element.dataset.image){
      productImages.forEach(function(productImage){
        productImage.srcset = "";
        productImage.src = element.dataset.image;
      });
    }
}
function setupEventsOnOptionsListItems(parentElement){
	var variantOptions = parentElement.querySelectorAll(".ProductItem__OptionListItem");
	variantOptions.forEach(function(variantOption){
		variantOption.addEventListener('click', function(){
			if(this.parentElement.querySelector('.ProductItem__OptionListItem.active')){
				this.parentElement.querySelector('.ProductItem__OptionListItem.active').classList.remove('active');
			}
			this.classList.add('active');	
			removeAddToCartBtn(this.parentElement.parentElement);	
			createAddToCartBtn(this);
			// changeImageToOptionSelected(this);
		});
	});
}
function createSecondLayerOfVariants(variants, element){	
	var parentElement = document.createElement('div');
	parentElement.className = "ProductItem__OptionList";
	variants.forEach(function(variant){
		var variantElement = document.createElement('div');
		variantElement.className = "ProductItem__OptionListItem";
		variantElement.dataset.id = variant.id;
		if(variant.featured_image){
			variantElement.dataset.image = variant.featured_image.src;
		} else if(variant.image){
			variantElement.dataset.image = variant.image;
		}
		var optionName = variant.options.filter(function(item){
			return item !== element.dataset.value;
		}).join('/');
		// if(variant.available && variant.featured_image && variant.featured_image.src){
		if(variant.available){
			variantElement.innerHTML = "<span>"+optionName+"</span>";      
			parentElement.append(variantElement);
		}
	});
	if(element.parentElement.parentElement.querySelector('.ProductItem__OptionList')){
		element.parentElement.parentElement.querySelector('.ProductItem__OptionList').remove();
	};
	element.parentElement.after(parentElement);
	setupEventsOnOptionsListItems(parentElement);
}
function getVariantsForColorSelected(productId, optionPosition, optionValue, element){
	//if(!productListVariants) return null;
	var productVariants = getProductListVariants(productId);
	if(!productVariants) return null;
	var variants = [];
	var image_main = '';
    productVariants.forEach(function(variant){
        // if(variant[optionPosition] === optionValue && variant.available && variant.featured_image && variant.featured_image.src){
		if(variant[optionPosition] === optionValue && variant.available){
            variants.push(variant);
            if(variant.featured_image){
                image_main = variant.featured_image.src;
            } else if(variant.image){
                image_main = variant.image;
            }
        }        
    });
    if(image_main) changeImageToOptionSelected(element, image_main);
	createSecondLayerOfVariants(variants, element);
}
setInterval(function setupColorSwatchesOnCardsAction(){
	var colorSwatchesOnCardsGroups = document.querySelectorAll('.quick-buy-options-wrapper:not(.event-set)');
	if(!colorSwatchesOnCardsGroups.length) return null;
	colorSwatchesOnCardsGroups.forEach(function(colorSwatchGroup){
		colorSwatchGroup.classList.add('event-set');
		var colorSwatchesOnCards = colorSwatchGroup.querySelectorAll('.color-swatch');
		if(!colorSwatchesOnCards.length) return null;
		colorSwatchesOnCards.forEach(function(colorSwatch){				
			colorSwatch.addEventListener('click', function(){
				if(this.classList.contains('.is-disabled')) return null;
				var productId = this.dataset.productId;
				var optionValue = this.dataset.value;
				var optionPosition = this.dataset.optionPosition;
				console.log(productId, optionValue, optionPosition);
				getVariantsForColorSelected(productId, 'option'+optionPosition, optionValue, this);
				// if(this.parentElement.parentElement.querySelector('.ProductItem__ColorSwatchItem .ColorSwatch.active')){
				// 	this.parentElement.parentElement.querySelector('.ProductItem__ColorSwatchItem .ColorSwatch.active').classList.remove('active');
				// }
				// this.classList.add('active');
				removeAddToCartBtn(this.parentElement.parentElement.parentElement);
			});
			if(colorSwatchesOnCards.length == 1){
				colorSwatch.click();
			}
		});	
	});
	 
},1000);

setInterval(function ocultaColorSwatchesSemEstoque() {
  // Seleciona todos os cards de produtos na página
  const productCards = document.querySelectorAll('.quick-buy-options-wrapper:not(.color-swatches-validados)');
  // Itera sobre cada card de produto
  productCards.forEach(card => {
    card.classList.add('color-swatches-validados');
    // Inicializa um objeto para armazenar as opções disponíveis
    const optionAvailable = {};
    // Seleciona o elemento que contém as variantes do produto
    const variant = card.querySelector('.product-list-item-variants');
    // Verifica se o elemento de variantes existe
    if (variant) {
      // Converte o atributo 'data-value' do elemento de variantes em um objeto JSON
      var variants = JSON.parse(variant.getAttribute('data-value'));
      // Itera sobre cada variante do produto
      variants.forEach(function(variant){
        // Itera sobre cada opção da variante
        variant.options.forEach(function(option){
            // Verifica se a variante está disponível
            if(variant.available && variant.featured_image && variant.featured_image.src){
                // Se a opção não estiver no objeto optionAvailable, adiciona-a como disponível
                if(!optionAvailable[option]) optionAvailable[option] = true;
            }
        });
      });
    }
    // Seleciona todos os swatches de cor do card
    const colorSwatches = card.querySelectorAll('.color-swatch');
	let colorSwatchesValidos = [];
    // Itera sobre cada swatch de cor
    colorSwatches.length > 1 && colorSwatches.forEach(swatch => {
        // Obtém o valor do swatch de cor
        const value = swatch.getAttribute('data-value');
        // Verifica se o valor do swatch está no objeto optionAvailable
        if (optionAvailable[value]) {
			colorSwatchesValidos.push(value);
            // Se estiver, remove a classe 'is-disabled' do swatch
            swatch.classList.remove('is-disabled');
        } else {
            // Se não estiver, remove o swatch da página
            swatch.remove();
        }
    });
	if(!colorSwatchesValidos.length && colorSwatches.length > 1) card.parentElement.parentElement.style.display = 'none';
  });
}, 2000);
ocultaColorSwatchesSemEstoque();
